import styled, { css } from 'styled-components'
import loaderGif from './loader.gif'

const Loader = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-image: url(${loaderGif});

  ${props => props.center ? css`
    margin: 0 auto;
  ` : ''}

  ${props => props.absoluteCenter ? css`
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -15px;
    margin-top: -15px;
  ` : ''}
`

export default Loader
